import { setRecursiveTimeout } from '@/utils';

export default function createListenerStore() {
	const state = {
		intervals: [],
		cleanUps: [],
	};

	function clearListeners(clearIntervals = true) {
		state.cleanUps.forEach(runCleanUp => runCleanUp());
		state.cleanUps = [];
		if (clearIntervals) {
			state.intervals.forEach(cancel => cancel());
			state.intervals = [];
		}

		for (const key in state) {
			if (['intervals', 'cleanUps'].indexOf(key) === -1) {
				delete state[key];
			}
		}
	}

	function setListener(fn = () => {}) {
		const cleanUp = fn(state);
		state.cleanUps.push(cleanUp);
	}

	function setIntervalListener(fn = () => {}, time = 2000) {
		state.intervals.push(setRecursiveTimeout(fn, time));
	}

	return {
		clearListeners,
		setListener,
		setIntervalListener,
	};
}
